import TourismResearch from "./TourismResearch.jsx";
export default TourismResearch